/**
 * Finance → Control Presupuestario: acceso (governance FINANCE_PNL_GOVERNANCE,
 * Juan Cruz + admins + viewers) y hooks del panel de permisos. Mismo molde que
 * useTalentAcquisition / useLearningGovernance.
 */

import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { trpc } from '@/lib/trpc';

export function useFinancePnlAccess() {
  return trpc.financePnl.checkAccess.useQuery(undefined, { staleTime: 60_000, retry: false });
}

export function useFinancePnlGovernance() {
  return trpc.financePnl.governance.getGovernance.useQuery(undefined, { retry: false });
}

export function useFinancePnlCommunityPicker() {
  return trpc.financePnl.governance.listCommunityForPicker.useQuery(undefined, { staleTime: 5 * 60_000, retry: false });
}

export function useSaveFinancePnlGovernance() {
  const { t } = useTranslation();
  const utils = trpc.useUtils();
  return trpc.financePnl.governance.setGovernance.useMutation({
    onSuccess: () => {
      utils.financePnl.governance.getGovernance.invalidate();
      utils.financePnl.checkAccess.invalidate();
      utils.profile.getVisibility.invalidate();
      toast.success(t('budget_control.governance.saved'));
    },
    onError: (e) => toast.error(e.message),
  });
}
